import { HttpClient } from '../httpClient';
import Credentials from '../models/credentials';
import AuthenticationResponse from '../responses/authenticationResponse';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import Email from '../models/email';
import ResetPassword from '../models/resetPassword';
import ForcedChangePassword from '../models/forcedChangePassword';
import CheckPreviousPasswordModel from '../models/checkPreviousPasswordModel';

const httpClient = new HttpClient();

export const postAuthenticate = async ({
  emailAddress,
  password,
  captchaToken,
}: Credentials) => {
  return httpClient.post<AuthenticationResponse>({
    url: '/v1/auth',
    payload: {
      emailAddress: emailAddress,
      password: password,
      captchaToken: captchaToken,
    },
    requiresToken: false,
  });
};

export const impersonateUser = async (userId: number) => {
  return httpClient.get<AuthenticationResponse>({
    url: `/v1/auth/impersonate/${userId}`,
    requiresToken: true,
  })
};

export const unimpersonateUser = async () => {
  return httpClient.get<AuthenticationResponse>({
    url: `/v1/auth/unimpersonate`,
    requiresToken: true,
  })
};

export const postRefreshToken = async (refreshToken: string) => {
  return httpClient.post<AuthenticationResponse>({
    url: '/v1/auth/refresh',
    headers: { Authorization: `Bearer ${refreshToken}` },
    requiresToken: false,
  });
};

export const postRevokeToken = async (refreshToken: string) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/auth/revoke',
    headers: { Authorization: `Bearer ${refreshToken}` },
    requiresToken: false,
  });
};

export const sendLinkResetPassword = async ({
                                              emailAddress,
                                              captchaToken,
                                            }: Email) => {
  return httpClient.post<AuthenticationResponse>({
    url: '/v1/Auth/sendLinkResetPassword',
    payload: {
      emailAddress: emailAddress,
      captchaToken: captchaToken,
    },
    requiresToken: false,
  });
};

export const resetPassword = async ({
                                      resetToken,
                                      newPassword,
                                      confirmPassword,
                                      emailAddress
                                    }: ResetPassword) => {
  return httpClient.post<AuthenticationResponse>({
    url: '/v1/Auth/resetPassword',
    payload: {
      resetToken: resetToken,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
      emailAddress: emailAddress,
    },
    requiresToken: false,
  });
};

export const forcedChangePassword = async ({
                                             newPassword,
                                             confirmPassword,
                                           }: ForcedChangePassword) => {
  return httpClient.post<AuthenticationResponse>({
    url: '/v1/Auth/forcedChangePassword',
    payload: {
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    },
    requiresToken: true,
  });
};

export const checkPreviousPasswords = async ({
  userId,
  email,
  newPassword
}: CheckPreviousPasswordModel) => {
  return httpClient.post<DataResponse<boolean>>({
    url: `/v1/auth/checkPreviousPasswords`,
    payload: {
      userId: userId,
      email: email,
      newPassword: newPassword,
    },
    requiresToken: false,
  })
}
